(function(){
  if(!window.matchMedia('(max-width: 989px)').matches)return;
  var bar=document.querySelector('.feli-mobile-bar');
  if(!bar)return;
  var search=bar.querySelector('[data-feli-mobile-search]');
  var cart=bar.querySelector('[data-feli-mobile-cart]');
  var chat=bar.querySelector('[data-feli-mobile-chat]');
  var count=bar.querySelector('[data-feli-cart-count]');
  function clickFirst(selectors){
    for(var i=0;i<selectors.length;i++){
      var target=document.querySelector(selectors[i]);
      if(target){target.click();return true;}
    }
    return false;
  }
  function syncCount(){
    var source=document.querySelector('.site-header .cartCount,.site-header .cart-count,.site-header [data-cart-count]');
    if(!source||!count)return;
    var value=(source.textContent||'').replace(/[^0-9]/g,'')||'0';
    count.textContent=value;
    count.hidden=value==='0';
  }
  function prepareChat(){
    var host=document.querySelector('shopify-chat');
    if(!host||!host.shadowRoot)return false;
    if(!host.shadowRoot.querySelector('[data-feli-chat-style]')){
      var style=document.createElement('style');
      style.setAttribute('data-feli-chat-style','');
      style.textContent='.activator{display:none!important}';
      host.shadowRoot.appendChild(style);
    }
    return true;
  }
  search.addEventListener('click',function(){
    if(!clickFirst(['.site-header a.searchIco','.searchIco','.header-search']))window.location.href='/search';
  });
  cart.addEventListener('click',function(){
    if(!clickFirst(['.site-header a.cartIco','.site-header .cart-link','a[href="/cart"].hdicon']))window.location.href='/cart';
  });
  chat.addEventListener('click',function(){
    var host=document.querySelector('shopify-chat');
    var trigger=host&&host.shadowRoot&&host.shadowRoot.querySelector('button.activator,button[aria-label*="Chat"],button');
    if(trigger)trigger.click();
  });
  syncCount();
  prepareChat();
  var countSource=document.querySelector('.site-header .cartCount,.site-header .cart-count,.site-header [data-cart-count]');
  if(countSource)new MutationObserver(syncCount).observe(countSource,{childList:true,subtree:true,characterData:true});
  var chatWait=new MutationObserver(function(){if(prepareChat())chatWait.disconnect();});
  if(!prepareChat())chatWait.observe(document.documentElement,{childList:true,subtree:true});
})();
